import { MatFormFieldDefaultOptions } from "@angular/material/form-field";

export const formFieldDefaultOptions: MatFormFieldDefaultOptions = {
  appearance: "fill",
  // the legacy form field reserved no space for hints/errors here (see styles/material/components.scss)
  subscriptSizing: "dynamic"
};
